
<div class="control-btn" (click)="onOpenClick()">
  Configure Channel Display Type
</div>

<ng-container
  *ngTemplateOutlet="optionWarning">
</ng-container>

<ng-container
  *ngTemplateOutlet="numberedListWarning">
</ng-container>

<ng-template #displayTypeModal>
  <div class="display-type-modal" (click)="onModalClick($event)">
    <div class="header-container">
      <p>Configure Channel Display Type</p>
      <div class="close-btn" (click)="onCloseClick()">
        <img src="../../../../../../../../assets/svg/close.svg" alt="">
      </div>
    </div>
    <div class="display-type-config-container">
      <div class="channel-list-container">
        <ul class="channel-list">
          @if (supportedChannels; as channels) {
            @for (channel of channels; track channel) {
              <li class="channel-list-item" (click)="setSelectedChannel(channel.channelId)" [ngClass]="selectedChannelId === channel.channelId ? 'selected-channel' : ''">
                <div class="channel-icon-container">
                  <img src="assets/img/channel/{{channel.channelId}}.svg" alt="">
                </div>
                <div class="channel-preview">
                  <div class="channel-name">{{channel.channelName}}</div>
                  <div class="applied-config">{{displayType.value[channel.channelId] | setDisplayTypeDisplayName: channel.channelId}}</div>
                </div>
              </li>
            }
          } @else {
            <loading-icon></loading-icon>
          }
        </ul>
      </div>
      <div class="display-type-selection-container">
        <ul class="display-type-list">
          @if (selectedChannelId) {
            @for (displayType of displayTypeOptionsPerChannels[selectedChannelId]; track displayType) {
              <li [ngClass]="selectedChannelType === displayType['type'] ? 'selected-display-type' : ''" (click)="onDisplayTypeSelected(displayType['type'])">
                @if (selectedChannelType === displayType['type']) {
                  <div class="checkmark-container"><img src="../../../../../../../../assets/svg/redesign/Check_Mark_Filled.svg" alt=""></div>
                } @else {
                  <div class="checkmark-container"><img src="../../../../../../../../assets/svg/redesign/check_mark_clear_bg.svg" alt=""></div>
                }
                <div class="display-type-text"
                                     [ngClass]="(selectedChannelId | customOptions: displayType['type'])  ?
                                     'display-type-text-width-whatsapp' : 'display-type-text-width-all'">
                  <div class="name">{{displayType['type'] | setDisplayTypeDisplayName: selectedChannelId}}</div>
                  @if (displayType['description']) {
                    <div class="description">{{displayType['description']}}</div>
                  }
                </div>
                @if (selectedChannelId | customOptions: displayType['type']) {
                  <div
                    class="more-info-container"
                    matTooltipClass="top-left-tooltip4"
                    matTooltip="Customize"
                    matTooltipPosition="above"
                    (click)="onOpenCustomListMessage()">
                    <div class="info-icon-container"><img src="../../../../../../../../assets/svg/noun_setting_grey.svg" alt=""></div>
                  </div>
                }
                <div class="more-info-container" (click)="onOpenMoreInfo($event, displayType.type)">
                  <div class="info-icon-container"
                    matTooltipClass="top-left-tooltip3"
                    matTooltip="More Info"
                    matTooltipPosition="above">
                    <img src="../../../../../../../../assets/svg/info.svg" alt="">
                  </div>
                </div>
              </li>
            }
          }
        </ul>

        <div class="custom-list-msg-slider" #customListMsgSlider>
          <div class="header">Customize List Messages</div>
          @if (showCustomMsgForm) {
            <form id="customListMsgForm" class="custom-list-msg-form" [formGroup]="customListButtonForm">
              <div class="control-div">
                <label class="control-label"> Button Text </label>
                <app-cms class="popover" [popoverText]="'Enter custom button text to open your WhatsApp interactive list. Default is “Options”.'"></app-cms>
                @for (error of customListButtonForm.controls['customListButton'].errors | keyvalue; track error) {
                  <div class="validationField">
                    <span class="fa fa-exclamation-circle"></span>
                    <span [id]="'validationField-menName'">
                      {{error.value}}
                    </span>
                  </div>
                }
                <input
                  type="text"
                  class="control-input"
                  [formControlName]="'customListButton'"
                  [placeholder]="'E.g. Options'"/>
                </div>
              </form>
            }
            <div class="button-container">
              <div class="close-btn" (click)="onCloseCustomMsgSlider()">
                Close
              </div>
              <div class="done-btn" (click)="onSubmit()" [ngClass]="!customListButtonForm.controls['customListButton'].errors ?  ' ' : 'done-btn-disabled'">
                Done
              </div>
            </div>

          </div>

          <div class="more-info-slider" #moreInfoSlider>
            <div class="close-btn" (click)="onCloseMoreInfoSlider()">
              Close
            </div>
            @if (displayInfo) {
              @if (cmsImageUrl !== '') {
                <div class="info-img-container">
                  <img class="cms-image" [src]="cmsImageUrl">
                </div>
              }
              <div class="info-description">
                {{ displayInfo?.['description'] }}
              </div>
              <div class="info-example">
                <div class="number-of-options">{{rangeDisplay}}</div>
                <div class="example">{{exampleDisplay}}</div>
              </div>
            } @else {
              <loading-icon></loading-icon>
            }
          </div>
          @if (warningMessage) {
            <div class="warning-message">
              <img class="warning-message_img" src="../../../../../../../../assets/svg/alert_traingle-filled.svg">
              <div class="warning-message_text">{{message}}</div>
            </div>
          }
        </div>
      </div>
      <div class="bottom-bar">
        <div [ngClass]="disableReset ? 'btn-disabled reset-btn-disabled' : 'btn reset-btn'" (click)="onResetClick()">
          Reset to Defaults
        </div>
        <div class="primary">
          <div class="btn cancel-btn" (click)="onCloseClick()"
            [ngClass]="showCustomMsgForm?  ' cancel-btn-disabled' : ' cancel-btn-enabled'">
            Cancel
          </div>
          <div class="btn save-btn" (click)="onSaveClick()"
            [ngClass]="displayType.valid && displayType.touched && !showCustomMsgForm?  'save-btn-enabled ' : 'save-btn-disabled'">
            Save
          </div>
        </div>
      </div>
    </div>


  </ng-template>

  <ng-template #optionWarning>
    @if (optionLength) {
      @for (channel of supportedChannels; track channel) {
        @if (displayIndex[channel.channelId][displayType.value[channel.channelId]]; as display) {
          <div>
            @if (display.max < optionLength && display.max > 0) {
              <div class="banner-container">
                <div class="banner-block">
                  <div class="icon"></div>
                  <div class="content">
                    You have {{ optionLength }} logic options. <span
                  style="text-transform:capitalize;">{{ display.name }}</span> menus can only
                  support up to {{ display.max }}. Additional options will not be displayed.
                  <a class="banner-link" target="_blank" href="https://clickatell.gitbook.io/flow/">
                    Read more.
                  </a>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  }
</ng-template>

<ng-template #numberedListWarning>
  @if (displayType.dirty && displayType.value['8'] !== 'NUMBER') {
    <div class="banner-container">
      <div class="banner-block">
        <div class="icon"></div>
        <div class="content">
          Only "Numbered List" supports formatting in the Menu Header. Please refrain from using
          formatting in the Menu Headers and Sub Headers of other display types.
          <a class="banner-link" target="_blank" href="https://clickatell.gitbook.io/flow/">
            Read more.
          </a>
        </div>
      </div>
    </div>
  }
</ng-template>